import { css } from '@emotion/react'
import { Theme } from '@mui/material'

export const valuesFormContainer = () => css`
  display: flex;
  flex-direction: column;
  padding-top: 24px;

  > h4 {
    font-size: 13px;
    font-weight: 400;
    margin-bottom: 4px;
  }
`

export const formHeader = css`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid rgba(0, 0, 0, 0.7);
  padding: 16px 0;

  h4 {
    margin: 0;
    font-size: 16px;
    font-weight: 500;
    align-self: flex-end;
  }

  .buttons {
    display: flex;
    gap: 8px;

    button {
      padding: 0 8px;
      font-size: 16px;
    }
  }
`

export const formBox = ({
  theme,
  showElements,
  isActive,
}: {
  theme: Theme
  showElements: boolean
  isActive: boolean
}) => css`
  display: flex;
  flex-direction: column;
  width: 420px;
  flex-shrink: 0;
  height: 100%;
  line-height: 1.2;
  transition: background-color 0.2s;
  background-color: ${showElements
    ? theme.palette.primary.dark
    : isActive
      ? theme.palette.primary[200]
      : theme.palette.grey[50]};

  box-shadow: ${isActive ? '0 8px 24px rgba(0,0,0,0.15)' : '4px 4px 4px rgba(216,216,216,0.15)'};

  transform: ${isActive ? 'scale(1)' : 'scale(0.96)'};
  opacity: ${isActive ? 1 : 0.65};
  transition: all 0.25s ease;
  // background-color: ${showElements ? theme.palette.primary.dark : theme.palette.white.main};
  box-shadow: ${showElements ? '' : '4px 4px 4px 0px rgba(216, 216, 216, 0.15)'};

  .buttons {
    position: absolute;
    bottom: 16px;
    padding: 0 16px;
    width: 100%;
    color: ${showElements ? theme.palette.white.main : theme.palette.primary.main};

    button {
      padding: 8px 16px;
      font-size: 14px;
      position: absolute;
      bottom: 0;
      right: 16px;

      &.elementButton {
        opacity: ${showElements ? 0 : 1};
        pointer-events: ${showElements ? 'none' : 'auto'};
        transition:
          opacity 0.2s,
          transform 0.2s ease-in-out;
      }
      &.sliderButton {
        opacity: ${showElements ? 1 : 0};
        pointer-events: ${showElements ? 'auto' : 'none'};
        transition:
          opacity 0.2s,
          transform 0.2s ease-in-out;
      }
    }
  }

  .header {
    display: flex;
    align-items: center;
    gap: 8px;

    h1 {
      font-size: 20px;
      font-weight: 700;
    }
    h2 {
      font-size: 14px;
      font-weight: 600;
    }
  }

  .content {
    flex-grow: 1;
    position: relative;

    .elementList {
      display: flex;
      flex-direction: column;
      padding: 40px;
      transition:
        opacity 0.2s,
        transform 0.2s ease-in-out;
      opacity: ${showElements ? 1 : 0};
      transform: ${showElements ? 'scale(1)' : 'scale(0.95)'};
      color: ${theme.palette.white.main};
      overflow: hidden;
      pointer-events: ${showElements ? 'auto' : 'none'};
      display: flex;
      justify-content: center;
      flex-direction: column;

      > * {
        opacity: ${showElements ? 1 : 0};
        transition: opacity 0.2s;
      }

      .elementBullets {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 8px;
        max-height: 140px;
        overflow-y: auto;
        overflow-x: hidden;

        &::-webkit-scrollbar {
          width: 8px;
          background-color: transparent;
        }
        &::-webkit-scrollbar-thumb {
          background-color: #fff8 !important;
          border-radius: 4px;
        }
        &::-webkit-scrollbar-track {
          background-color: #fff1 !important;
          border: none !important;
        }

        > * {
          display: flex;
          flex-direction: column;
          gap: 8px;
        }

        li {
          margin-left: 24px;
        }
      }

      h2 {
        margin-bottom: 12px;
      }
    }

    .valueForm {
      flex-grow: 1;
      padding: 0 40px;
      padding-bottom: 40px;
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      transition: opacity 0.2s ease-in-out;
      opacity: ${showElements ? 0 : 1};
      pointer-events: ${showElements ? 'none' : 'auto'};
      display: flex;
      justify-content: center;
      flex-direction: column;
      gap: 32px;
      color: ${theme.palette.uintel.dark};

      p {
        font-size: 14px;
        margin-bottom: 24px;
      }
    }
  }
`

export const formBoxRow = css`
  display: flex;
  gap: 16px;
  padding: 16px 0;
  height: 340px;

  width: 100%;
`
